import { useMutation } from "react-query";
import { createTelehealthPrerequisites, updateTelehealthPrerequisites } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpsertTelehealthPrerequisites = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload, isNew = false }: { clientId: number; payload: Record<string, any>; isNew?: boolean }) =>
      isNew ? createTelehealthPrerequisites(clientId, payload) : updateTelehealthPrerequisites(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving the telehealth prerequisites.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    upsertTelehealthPrerequisitesMutation: mutate,
    isUpsertTelehealthPrerequisitesLoading: isLoading,
    ...rest,
  };
};

export default useUpsertTelehealthPrerequisites;
